import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as artistsActions from '../../store/actions/artistsActions'

const ArtistDelete = props => {
    const onClick = e => {
        e.preventDefault()

        if(window.confirm('Esti sigur?')) {
            props.artistsActions.remove(props.id)
        }
    }

    return (
        <a onClick={onClick}><i className="material-icons">delete_forever</i></a>
    )
}

const mapStateToProps = (state, props) => {
    return {
        artists: state.artists.artists
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        artistsActions: bindActionCreators(artistsActions, dispatch)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ArtistDelete)


// WEBPACK FOOTER //
// ./src/components/artists/ArtistDelete.js